module.exports = __webpack_public_path__ + "static/media/TMT 3c3.c1e47fd5.jpg";